
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coupons",
      function () {
        return require("private-next-pages/coupons.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coupons"])
      });
    }
  